<template>
    <div class="tools-tab tools-tab-duty">
        <ul class="list list-duties">
            <li v-for="duty in duties" :class="[hasDuty(duty) ? 'is-active' : '']" @click="select(duty)">
                <em :style="'background:' + duty.color">{{ duty.identifier }}</em>
                <span>{{ duty.name }}</span>
                <icon name="check" />
            </li>
        </ul>
    </div>
</template>

<script>
import events from '../../../events/events';
import shared from '../../../pages/planning/shared';

export default
{
    name: 'Duty',

    props: ['item'],

    data() {
        return {
            shared: shared.state,
        }
    },

    computed:
    {
        activeDuties()
        {
            // TODO: might need to add legacy duty as well, if previously assigned!
            return _.filter(this.shared.duties, {trashed: false});
        },

        // only show duties for this user
        duties()
        {
            // no user set? return all duties!
            if ( ! this.item.assigned) return this.sort(this.activeDuties);

            return this.sort(this.filter(this.activeDuties));
        },
    },

    methods:
    {
        filter(duties)
        {
            // get all duties of assigned user
            let user = shared.getUser(this.item.user);

            return _.filter(duties, duty =>
            {
                return (user.duties.indexOf(duty.id) !== -1);
            })
        },

        sort(duties)
        {
            return _.sortBy(duties, ['name']);
        },

        hasDuty(duty)
        {
            return duty.id == this.item.duty;
        },

        select(duty)
        {
            if (shared.hasApplications(this.item)) return;
            
            this.$http.put(
            '/api/items/' + this.item.id + '/duty',
            {
                duty: duty.id
            })
            .then(response =>
            {
                let key = _.findIndex(this.shared.items, {id: this.item.id});

                // replace item
                this.$set(this.shared.items, key, response.data);

                this.$tools.replacePayload(response.data);
            
                events.$emit('recalculate', response.data.date);

                // this.$tools.close();
            })
            .catch(error =>
            {
                switch (error.response.data.error)
                {
                    case 'ERR_CONFIRMED':
                        // cannot remove times because hours have already been confirmed
                        this.$modal.show(this.$t('page.roster.duty.error.headline'), this.$t('page.roster.time.error.ERR_CONFIRMED'));
                    break;
                }
            });
        },

        // deprecated:
        // remove(duty)
        // {
        //     this.$http.delete(
        //     '/api/items/' + this.item.id + '/duty')
        //     .then(response =>
        //     {
        //         if (response.data)
        //         {
        //             this.item.duty = null;
        //         }
        //         else
        //         {
        //             let key = _.findIndex(this.shared.items, {id: this.item.id});
        //
        //             // remove item
        //             this.$delete(this.shared.items, key);
        //         }
        //
        //         this.$tools.close();
        //     })
        //     .catch(error =>
        //     {
        //         // error
        //     });
        // },
    },
}
</script>



// WEBPACK FOOTER //
// Duty.vue?312dbbfb